import { AtomicExternalWrapper } from '@components/Search/AtomicExternalWrapper';
import { AtomicSearch } from '@components/Search/AtomicSearch';
import { AtomicSearchInterfaceWrapper } from '@components/Search/AtomicSearchInterfaceWrapper';
import { HeaderSearch as HeaderSearchV2 } from '@components/SearchV2/HeaderSearch';
import { AtomicSearchContext } from '@contexts/coveo/AtomicSearchContext';
import { useFlags } from '@lib/flags/amplitude/client';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';
import { usePathname } from 'next/navigation';
import { getWithoutLocale } from 'utils';
import { HeaderSearch } from './Search';

/* Handles returning either the old Search or the Atomic Coveo Searchbox */
export const SearchWrapper = ({
  searchPlaceholder,
}: {
  searchPlaceholder: string;
}) => {
  const { flags, loading } = useFlags();
  const isCoveoSearchEnabled =
    flags?.[Flags.COVEO_SEARCH]?.value === FLAG_TREATMENT;
  const isSearchV2Enabled = flags?.[Flags.SEARCH_V2]?.value === FLAG_TREATMENT;
  const pathname = usePathname() || '/';
  const pathnameWithoutLocale = getWithoutLocale(pathname);
  const isOnSearchV2Page = pathnameWithoutLocale === '/search-v2';
  const isOnACoveoResultsPage =
    pathnameWithoutLocale === '/search' ||
    pathnameWithoutLocale === '/search-v2' ||
    pathnameWithoutLocale === '/listing';
  const searchRoute = isSearchV2Enabled ? '/search-v2' : '/search';

  if (loading) {
    return null;
  }

  // On /search-v2, use the Headless engine directly — no AtomicSearchInterface needed
  if (isCoveoSearchEnabled && isOnSearchV2Page) {
    return <HeaderSearchV2 placeholder={searchPlaceholder} />;
  }

  return (
    <>
      {isCoveoSearchEnabled ? (
        <>
          <AtomicExternalWrapper
            id="atomic-search-external"
            context={AtomicSearchContext}
            atomicSearchInterfaceSelector="#atomic-search-interface_search"
          >
            <AtomicSearch searchRoute={searchRoute} />
          </AtomicExternalWrapper>
          {/*
           * On /search and /listing pages, the content of the page is wrapped in a SearchInterface.
           * On other pages, we need a search interface here to initialize the header searchbox.
           */}
          {!isOnACoveoResultsPage && (
            <AtomicSearchInterfaceWrapper
              id="atomic-search-interface_search"
              shouldExecuteFirstSearch={false}
              reflectStateInUrl={true}
              context={AtomicSearchContext}
            />
          )}
        </>
      ) : (
        <HeaderSearch placeholder={searchPlaceholder} />
      )}
    </>
  );
};
